import React, {useEffect, useState} from "react"
import {apiGet} from "../../../Api/index";
import {Div, Text} from "atomize";
import theme from "../../../Theme/Theme";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import ItemsCarousel from 'react-items-carousel';
import ArrowButton from "../../Atoms/ArrowButton";
import {ReactComponent as LeftIcon} from "../../../Assets/Icons/arrow_left.svg";
import {ReactComponent as RightIcon} from "../../../Assets/Icons/arrow_right.svg";
import OutcomesItem from "../../Molecules/OutcomesItem";


const Wrapper = styled(Div)`
  margin-top: 6rem;
  border: 1px solid ${theme.colors.primary};
  padding: 2rem;
  margin-top: 6rem;
  margin-bottom: 6rem;
  display: flex;
  align-items: center;
  flex-direction: column;
    
  &.border {
    position: relative;
    background: white;
    
    &:before {
      border: 1px solid ${theme.colors.primary};
      display: block;
      height: 100%;
      width: 100%;
      content: "";
      left: 5px;
      position: absolute;
      top: 5px;
      z-index: -1;
    }
  }
`;

const Heading = styled.div`
  border: 1px solid ${theme.colors.primary};
  border-radius: 25.5px;
  display: inline-flex;
  padding: .5rem 1rem;
  margin-top: -54px;
  background-color: white;
  color: ${theme.colors.primary};
  font-family: Inter;	
  font-size: 14px;
`;

const SliderWrapper = styled.div`
  width: 100%;
`;

function Outcomes(props) {
  const [data, setData] = useState({});
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 0;

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/paragraph/learning_outcomes/${props.id}?include=field_learning_outcomes&jsonapi_include=1`);
      setData(result.data.data);
    }

    fetchData();
  }, []);

  return (
    <Wrapper className={'border'}>
      <Heading> Outcomes { data.field_learning_outcomes && activeItemIndex + 1 + " / " + data.field_learning_outcomes.length} </Heading>
      <SliderWrapper>
        {
          data.field_learning_outcomes &&
          <ItemsCarousel
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={1}
            gutter={-2.5}
            leftChevron={<ArrowButton aria-label={'scroll activity bundles left'}>{<LeftIcon />}</ArrowButton>}
            rightChevron={<ArrowButton aria-label={'scroll activity bundles right'}>{<RightIcon/>}</ArrowButton>}
            outsideChevron
            chevronWidth={chevronWidth}
            classes={{ wrapper: 'carousel-wrapper' }}
            showSlither={true}
          >
            {
              data.field_learning_outcomes.map( (outcome, i) => {
                return (
                  <OutcomesItem
                    key={outcome.id + i}
                    outcome={outcome}
                  />
                )
              })
            }
          </ItemsCarousel>
        }
      </SliderWrapper>
    </Wrapper>
  )
}


export default Outcomes
